import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Comments from '@src/pc/components/Comments';
import styles from './index.css';

const CommentModal = ({ close, subjectId }) => {
    return (
        <div className={styles.wrap}>
            <div className={styles.nav}>
                <div className={styles.title}>热门评论</div>
                <div
                    className={styles.close}
                    onClick={() => {
                        close();
                    }}
                />
            </div>
            <div className={styles.comment}>
                <Comments subjectId={subjectId} />
            </div>
        </div>
    );
};

CommentModal.propTypes = {
    subjectId: PropTypes.string,
    close: PropTypes.func,
};

export default errorBoundary(CommentModal);
